import Utils from "./utils.class";
const { jQuery: $ } = window;

export default class Trustarc {

    #events = {
        ready: "kmdg_trustarc_ready",
        consent: {
            functional: "kmdg_trustarc_functional_consent",
            advertising: "kmdg_trustarc_advertising_consent",
        },
        denied: {
            functional: "kmdg_trustarc_no_functional_consent",
            advertising: "kmdg_trustarc_no_advertising_consent",
        }
    }

    constructor($body) {
        Utils.log("Registered: Trustarc");

        $(() => {
            // Wait for API to be ready then start triggering events.
            if(typeof window.truste === "undefined" || window.truste === null || typeof window.truste.cma === "undefined") {
                const TrustArcWatcher = setInterval(() => {
                    if(typeof window.truste !== "undefined" && window.truste !== null && typeof window.truste.cma !== "undefined") {
                        clearInterval(TrustArcWatcher);

                        $(window).trigger(this.events.ready);
                    }
                }, 100);
            } else {
                setTimeout(() => {
                    $(window).trigger(this.events.ready);
                }, 1);
            }
        });

        window.addEventListener("message", (event) => {
            try {
                const data = JSON.parse(event.data);

                if (data.source === "preference_manager" && data.message === "submit_preferences") {
                    let consentDecision;

                    try {
                        consentDecision = data.data.split(",");
                    } catch (e) {
                        // Implied consent banner sends a different format than preferences popup
                        consentDecision = data.data.value.split(",");
                    }

                    Utils.log("TrustArc API Prefs Change:", consentDecision);

                    // Weirdly these numbers do not match up to the normal permission levels
                    if(consentDecision.includes("1")) {
                        $(window).trigger(this.events.consent.functional);
                    } else {
                        $(window).trigger(this.events.denied.functional);
                    }

                    if(consentDecision.includes("2")) {
                        $(window).trigger(this.events.consent.advertising);
                    } else {
                        $(window).trigger(this.events.denied.advertising);
                    }
                }
            } catch (e) {}
        });

        $(window).on(this.events.ready, () => {
            Utils.log("TrustArc API Ready");
            const response = window.truste.cma.callApi("getGDPRConsentDecision", window.location.host);
            let consentDecision = response.consentDecision;
            let consentType = window.truste.cma.callApi("getConsent", window.location.host);

            Utils.log(response);

            if(!Array.isArray(consentDecision)) {
                consentDecision = [consentDecision];
            }

            if(consentDecision.includes(2) || (consentType.source === "implied" && consentType.consent === "approved")) {
                $(window).trigger(this.events.consent.functional);
            } else {
                $(window).trigger(this.events.denied.functional);
            }

            if(consentDecision.includes(3)) {
                $(window).trigger(this.events.consent.advertising);
            } else {
                $(window).trigger(this.events.denied.advertising);
            }
        });

        $(window).on(this.events.consent.functional, function() {
            // Its safe to use any scripts that rely on functional cookies here. This can fire multiple times.
            Utils.log("Have trustarc functional consent");

            $body.removeClass("js__consent--no-functional");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--functional");
        });

        $(window).on(this.events.consent.advertising, function() {
            // Its safe to use any scripts that rely on advertising cookies here. This can fire multiple times.
            Utils.log("Have trustarc advertising consent");

            $body.removeClass("js__consent--no-advertising");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--advertising");
        });

        $(window).on(this.events.denied.advertising, function() {
            // Fired when revoking advertising consent. This can fire multiple times.
            Utils.log("No trustarc advertising consent");

            $body.removeClass("js__consent--advertising");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--no-advertising");
        });

        $(window).on(this.events.denied.functional, function() {
            // Fired when revoking functional consent. This can fire multiple times
            Utils.log("No trustarc functional consent");

            $body.removeClass("js__consent--functional");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--no-functional");
        });

        $(".js--open-trustarc").on('click', function () {
            // Redirects a click on our custom button to the actual cookie link (since that seems to be the only way to open the popup)
            $("#teconsent a").trigger('click');
        });
    }

    get events() {
        return this.#events;
    }
}